import { render, staticRenderFns } from "./zcy.vue?vue&type=template&id=21476f7a&scoped=true"
import script from "./zcy.vue?vue&type=script&lang=js"
export * from "./zcy.vue?vue&type=script&lang=js"
import style0 from "./zcy.vue?vue&type=style&index=0&id=21476f7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21476f7a",
  null
  
)

export default component.exports